// Display-time cleanup for security names returned by SnapTrade / Plaid.
// The provider feeds carry trailing noise like "Vanguard S&P 500 ETF" or
// "SPDR S&P 500 ETF Trust"; users find the ticker + trimmed name easier to
// scan. Longest suffix matches first so "ETF Trust" wins over "ETF".

export function cleanSecurityName(name) {
  if (!name) return name;
  return name
    .replace(/\s+ETF Trust$/i, '')
    .replace(/\s+Index Fund ETF$/i, '')
    .replace(/\s+ETF$/i, '');
}
